import Vue from 'vue'
import Router from 'vue-router'
import Welcome from '@/components/Welcome'
import Home from '@/components/Home'
import FeatureOne from '@/components/FeatureOne'
import FeatureTwo from '@/components/FeatureTwo'
import Unbound from '@/components/Unbound'
import Download from '@/components/Download'

Vue.use(Router)

const router = new Router({
  routes: [
    {
      path: '/',
      redirect: '/welcome'
    }, {
      path: '/welcome',
      name: 'Welcome',
      component: Welcome
    }, {
      path: '/unbound',
      name: 'Unbound',
      component: Unbound
    }, {
      path: '/home',
      name: 'Home',
      component: Home
    }, {
      path: '/hb',
      name: 'FeatureOne',
      component: FeatureOne
    }, {
      path: '/ca',
      name: 'FeatureTwo',
      component: FeatureTwo
    }, {
      path: '/download/:dl_name/:dl_id',
      component: Download,
      props: true
    }
  ]
})

export default router



// WEBPACK FOOTER //
// ./src/router/index.js